export const headers = [
  { content: "" },
  { content: "Member", isCheckBox: true },
  { content: "Role" },
  { content: "User Type" },
  { content: "Property" },
  { content: "Inncode" }
];
export const assignCopyHeaders = [
  { content: "" },
  { content: "Member", isCheckBox: true },
  { content: "Role" },
  { content: "User Type" }
];
